import { CheckCircle } from "lucide-react";

const RXTApplications = () => {
  const applications = [
    {
      title: "Meeting & Conference Rooms",
      items: [
        "Full conference room automation and control",
        "Video conferencing with WordGate™ camera tracking on all models",
        "Content sharing via VPX AVoIP (DV models) or RTSP streams (all models)",
        "Voting system functionality for decision making",
        "Room booking capabilities with status display",
        "Name placeholder display for participants"
      ]
    },
    {
      title: "Educational & Corporate",
      items: [
        "Educational facility integration and control",
        "Live streaming and recording capabilities",
        "Multi-source content presentation (DV models)",
        "Hospitality system management",
        "Digital signage applications",
        "Raise hand function for interactive meetings"
      ]
    }
  ];

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Applications & Features</h2>
      <div className="grid gap-6 md:grid-cols-2">
        {applications.map((application, index) => (
          <div key={index} className="bg-card rounded-lg p-6 border shadow-sm">
            <h3 className="text-lg font-semibold mb-3 text-[#069E50]">{application.title}</h3>
            <ul className="space-y-2">
              {application.items.map((item, itemIndex) => (
                <li key={itemIndex} className="flex items-start gap-2">
                  <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RXTApplications;
